/* eslint-disable max-len */

export default {
  lang: 'Japanese',
  homeScreen: {
    title: '情熱を分かち合いましょう',
    stayConnected: 'つながっていよう',
    comingSoon: 'まもなく開始',
    messages: 'メッセージ',
  },
  loginScreen: {
    version2: {
      homeTitle: '私たちのシステムで、あなたの既存のプロフィールが見つかるか確認してみましょう。',
      homeTitleSub: 'トレーニングプログラムへのログインに通常使用するメールアドレスを入力してください。',
      noAccount:
        'アカウントが見つかりません({email})。別のメールアドレスで試すか、今すぐアカウントを作成してください。',
      continueButton: '続ける',
      success: 'アカウントの更新に成功しました！まもなくホームページに移動します。',
      successNewAccount: '登録を完了するには、アカウントを確認するための確認メールが送信されます。',
      loginButton: 'ログイン',
      matchFound: '一致する情報が見つかりました。パスワードを入力して次に進んでください。',
      magicLink: 'Eメールのリンクからログインしてください：',
      magicLinkButton: 'マジックリンクのリクエスト',
      magicLinkTitle: 'あなたのEメールに直接リンクが送られ、すぐにサインインできます。',
      otherEmailButton: '投稿する',
      title: 'あなたの個人プロフィールと連絡先情報が入力されますので、以下のすべての情報を入力してください。',
      titleIndustry: 'あなたの個人プロフィールと連絡先情報が入力されますので、以下のすべての情報を入力してください。',
      register: 'アカウントの作成',
      agent: 'トラベル・アドバイザー',
      visitor: '業界ビジター',
      step1: 'ステップ1：ユーザーのタイプ',
      step2: 'ステップ 2: アカウントの作成',
      step3: 'ステップ3：プロフィールの作成',
      milesAttack: 'Do you have a Miles Attack code? Indicate the 4 letters',
      marketingOptIn: 'このプログラムのトラベル・トレード・チームとのつながりを維持することに興味はありませんか？',
      optIn: 'はい、興味があります',
      optOut: '興味なし',
      step2Sub1: 'あなた自身について教えてください',
      step2Sub2: 'あなたのビジネスについて教えてください',
      privacyHead: '通信設定',
      privacySub:
        '以下のボックスにチェックを入れると、サプライヤーの旅行業界チームからの重要な連絡（商品の最新情報やお知らせ、特典、インセンティブ、FAMなど）や、TravPRO Mobileからの旅行業界ネットワーキングや営業支援イニシアチブを確実に受け取ることができます。',
      privacy:
        '当社はお客様のプライバシーを保護し、お客様の信頼を売り渡したり、悪用したり、裏切ったりすることは決してありません。',
      store: 'アプリストアで簡単にダウンロードできます：',
      powered: 'パワー・バイ',
      toastMessage: {
        forgotSuccess:
          'パスワードリセットリンクをEメールで送信しました！10秒後にログインページにリダイレクトされます。',
        emailNotExisting: '入力されたEメールアドレスが存在しません。',
        magicLinkMessage: '今、サインインしているところですので、お待ちください。',
        magicLinkError:
          'データベースにお客様のアカウントが見つかりませんでした。手動でログインしてください。10秒後にリダイレクトされます。',
        magicLinkError1:
          '有効なトークンが見つかりませんでした。ログインするか、新しいマジックリンクをリクエストしてください。この問題が解決しない場合は、info@travpromobile.com。',
        magicLinkError2:
          'データベースにお客様のアカウントが見つかりませんでした。手動でログインしてください。10秒後にリダイレクトされます。',
        magicLinkSuccess: 'email}でメールをチェックしてください。魔法のリンクでサインインできます。',
        magicLinkErrorWait: 'マジックリンクリクエストの間は5分間お待ちください。',
        emailNotFoundError:
          '入力されたメールアドレスが当社の記録にありません。スペルミスをチェックするか、アカウントを作成してください。',
      },
      errors: {
        zipCodeNotFound: '郵便番号が見つかりません。',
        zipCodeOnlyNumbers: 'ZipCode には数字のみを含めることができます。',
        password: 'パスワードを入力してください',
        passwordNotMatching: '入力したパスワードが一致しません。',
        passwordTooShort: 'パスワードは8文字以上',
        emailExists:
          'このメールアドレスは既に存在するか、無効です。別のメールアドレスで試すか、アカウントにログインしてください。',
        fillInAllFields: '必須項目をすべてご記入ください。',
        fillInEmail: 'Eメールをご記入ください。',
        emailNotExisting: '入力されたEメールアドレスが存在しません。',
      },
      fields: {
        forgotSubCopy: 'パスワードをお忘れですか？',
        forgotSubCopy2:
          'パスワードを完全に回避したいですか？自動的にプログラムにログインできる魔法のリンクをメールでお送りします。',
        city: '都市',
        companyName: '会社名',
        role: 'あなたの役割',
        description: '御社の事業内容を最もよく表しているのはどれですか？',
        country: '国名',
        password: 'パスワード',
        passwordRegister: 'パスワードの選択（最低8文字）',
        passwordConfirm: 'パスワードの確認',
        firstName: 'ファーストネーム',
        lastName: '姓（家族）',
        agency: '代理店名',
        title: 'あなたの役割（1つを選択）',
        company: '会社名',
        select: '以下のオプションを選択してください。',
        state: '州',
        province: '都道府県',
        zipCode: '郵便番号',
        postalCode: '郵便番号',
        affiliate: '主な所属事務所はどのグループですか？',
        hostAgency: 'ホスト・エージェンシー？',
        executive: 'エグゼクティブ',
        management: 'マネジメント',
        marketing: 'マーケティング',
        sales: '売上高',
        coordinator: 'コーディネーター',
        opt: 'このプログラムのトラベル・トレード・チームと連絡を取り合い、最新情報を受け取る。',
        optMarketing: '同様のプログラムやイベントに関して、TravPROと連絡を取り合ってください。',
        retail: '店舗フロント',
        home: '在宅エージェント',
        independent: 'インディペンデント・コントラクター',
        host: 'ホスト・エージェンシー',
        call: 'コールセンターまたはウェブベースの代理店',
        other: 'その他',
        describes: 'あなたやあなたの代理店の事業を最もよく表しているものは何ですか？',
        milesAttack: 'Code Miles Attack (facultatif)',
      },
    },
    title: '旅行業者のトレーニング & セールスイネーブルメントプログラム',
    welcome: {
      headerTop: 'カナダスペシャリストプログラムに',
      headerBottom: 'ようこそ',
    },
    sellingPoints: {
      0: 'どこでも学んで販促',
      1: '好きなデバイスでのマルチメディアトレーニング',
      2: '修了証書',
      3: 'すぐに使えるプレゼン資料',
      4: 'インパクトを高める営業資料',
      5: '知っておくと便利な情報とプロモーション',
      6: 'リアルタイム商品案内',
      7: 'ニュース & 最新情報',
    },
    emailPrompt: 'あなたが旅行業者であることを当方が確認できるよう、メールアドレスとパスワードの入力をお願いします。',
    tAndC: {
      agree: '続行することで、',
      privacyPolicy: '当社のプライバシー ポリシー',
      and: 'および',
      termsConditions: '利用規約に同意したものとみなされます',
    },
    forgot: 'パスワードのリセット',
    fields: {
      select: '以下のオプションを選択してください',
      country: '国',
      forgot:
        'パスワードをお忘れですか？下のボタンをクリックすると、パスワードをリセットするためのメールをお送りします。',
      agency: '旅行業者',
      email: 'Eメール',
      password: 'パスワード',
      passwordConfirm: 'パスワードを確認する',
      firstName: '名',
      lastName: '姓',
      agencyName: '旅行業者の名前',
      stateProvince: '都道府県',
      required: '必須',
      invalidEmail: 'メールアドレスが無効です',
      opt: 'つながっていよう！ はい、デスティネーションカナダからニュース、イベント、奨励金、FAM などに関する最新情報を受信することを希望します。',
    },
    noAgent: {
      noAgentButton: '私はアドバイザーではない',
      title: 'カナダスペシャリストプログラムにご関心をお寄せいただきありがとうございます。',
      messageWeb: '本サイトのコンテンツは旅行業者専用です。 \n  カナダに関する詳しい情報は、ぜひこちらをご覧ください:',
      messageMobile:
        'このアプリの一部のコンテンツは旅行業者専用ですが、その他のコンテンツをお楽しみいただけます。「続行」を押すとプレビューをご覧いただけます。',
      continue: '続行',
      visitWebsite: 'ウェブサイトを見る',
    },
    newUser: '新しいユーザー',
    register: '登録',
    registered: 'このメールアドレスは登録済みです',
  },
  welcomeScreen: {
    title: 'カナダスペシャリストプログラムにようこそ',
    helloUser: 'こんにちは、{{name}} さん',
    hello: 'こんにちは、',
    fromAgency: 'さん ({{agency}})',
    notUser: '{{name}} さんではありませんか？',
    introOnline:
      'オンラインですぐにトレーニングを行うことも、コンテンツを事前に読み込んであとでオフラインで利用することもできます。',
    introOffline: 'すでに最新バージョンが読み込まれています。 トレーニングも販売も、いつでもどこでも開始できます！',
    startTraining: '学習を開始',
    continueTraining: '学習を続行',
    graduated: 'おめでとうございます。',
    downloader: {
      preload: '事前に読み込む',
      stop: '停止',
      init: '初期化中...',
      lastUpdate: '最終更新:',
    },
  },
  trainingScreens: {
    completedBase: 'おめでとうございます。あなたはカナダの認定スペシャリストです。',
    allUnlocked: '全チャプターのロックを解除しました。',
    certificate: '証書',
    chapter: 'チャプター',
    chapterComplete: 'チャプターを完了しました！',
    choose: '回答を選択してください',
    confirm: '回答を確定する',
    continue: '続行',
    welcome:
      'モジュールを次々と完了していくと、ポイントが加算され、最後には「ゴールド」カナダスペシャリストになることができます。 進捗状況は右側のバーに表示されます。',
    courseComplete: 'コースを完了しました！',
    durationInMinutes: '{number} 分',
    endReached: '終わりに達しました',
    essential: '基礎',
    essentialSub: 'これらの基礎モジュールを終了すると、「ブロンズ」ステータスを獲得できます。',
    message: '{count} 件の STAR メッセージ',
    messagePlural: '{count} 件の STAR メッセージ',
    percentageComplete: '{number}% 完了',
    restart: 'リスタート',
    retainEnd: '上のバーを使用してこのチャプター内をナビゲートできます。「戻る」ボタンを押すと概要に戻ります。',
    retry: 'もう一度試す',
    skip: '戻る >',
    viewAllTitle: 'トレーニングのアドバイス',
    viewAll:
      '次のページに進むには、補足コンテンツアイコンをクリックしてください。 トレーニングの効果を上げ、PRO ステータスに到達していただけるよう、ビデオ、マップ、その他の役立つ情報が提供されています。',
    specialization: '専門モジュール',
    specializationSub: 'これらのモジュールを完了すると、「シルバー」カナダスペシャリストステータスを獲得できます',
    start: '開始',
    review: 'レビュー',
    status: '現在のステータス:',
    tip: '各段階のモジュールを完了すると、<br />段階に応じたステータスを獲得します。 <br />すべてのモジュールを完了して<br />「ゴールド」カナダスペシャリストステータスを獲得しましょう！',
    trouble: '問題が発生したようです。前のページのコンテンツを再びお読みになり、もう一度お試しください。',
    unlock: 'トレーニングチャプター {number} を完了すると、このチャプターのロックが解除されます。',
    unlockSubtitle: 'トレーニングチャプターを完了するに従い、より多くのチャプターのロックが解除されます。',
    watchListenRead: '続きを視聴・閲覧する',
  },
  newTrainingFlow: {
    tip: 'アドバイス: 各段階のモジュールを完了すると、段階に応じたステータスを獲得できます。 すべてのモジュールを完了すると、「ゴールド」カナダスペシャリストステータスを獲得できます',
    essentialModules: '重要な章',
    finishBronze: 'これらのモジュールを完了すると、「ブロンズ」カナダスペシャリストステータスを獲得できます',
    specializationModules: '専門モジュール',
    finishSilver: 'これらのモジュールを完了すると、「シルバー」カナダスペシャリストステータスを獲得できます',
    partnerModules: 'パートナーモジュール',
    finishGold:
      'あなたの知識を次のレベルに引き上げ、各州、地域、または市の章を完了するたびにバッジを獲得しましょう。29の総章のうち10を完了すると、GOLDステータスが与えられます。29の総章のうち22を完了すると、最高のスペシャリストステータスであるPLATINUMに達します！',
    currentStatus: '現在のステータス',
    pointsToLevel: '{pointsToLevel} 中 {points}',
    reachedRanking: ': {rank} ランク到達までに必要なポイント数です。',
    outOf: '{points} XP (全',
    pointsToRank: '{pointsToLevel} XP 中): {rank} ランク到達までに必要なポイント数です。',
  },
  popUp: {
    congratulations: 'CONGRATULATIONS!',
    bronze:
      'よくやった！ カナダの基本事項をすべて学び、BRONZE ステータスを獲得しました。 次に、訪問者がここで体験できるさまざまな種類の体験を探ります.',
    silver:
      'おめでとう！ The Foundation と The Experience のすべてのモジュールを正常に完了することにより、認定されたカナダ スペシャリストとしてのディプロマを取得しました。 また、SILVER ステータスも達成しており、以下の州、準州、および都市のセクションに進むことで、GOLD およびその先に進む準備ができています。 これからもいい結果を出し続けてください！',
    gold: 'よくやった! 10 の州、準州、都市のモジュールを正常に完了し、GOLD ステータスを獲得しました。 さらに 12 を完了することを選択すると、完全な PLATINUM レベルのカナダ スペシャリストになります!',
    platinum:
      'おめでとう！！ あなたは PLATINUM ステータスを獲得しました。これは、認定されたカナダ スペシャリストとしての最高レベルの資格です。 カナダでの販売における多大な努力とパートナーシップに感謝します.',
    platinumWithLink: {
      start:
        'You have just achieved PLATINUM status as a Canada Specialist. You are truly at the top of the class now, well done! You have earned some rewards for your hard work. Click',
      end: 'to visit your Achievements Dashboard and learn how to redeem exclusive PLATINUM deals and offers from our partners.',
      link: 'HERE',
    },
  },
  points: {
    pointsToLevel: '{pointsToLevel} 中 {points}: {rank} ランク到達までに必要なポイント数です。',
    outOf: '{points} XP (全',
    unit: 'XP',
    pointsToRank: '{pointsToLevel} XP 中): {rank} ランク到達までに必要なポイント数です。',
    complete: {
      chapter: 'チャプターを完了しました！',
      'intro-chapter': '入門チャプターを完了しました！',
      'sub-app': 'SubApp を完了しました！',
      rewards: 'リワードを完了しました！',
      multi: 'ポイントが加算されます！',
    },
    completed: '{completed} / {total} 完了',
  },
  nav: {
    achievements: '実績',
    home: 'ホーム',
    train: '学習する',
    learn: '学習する',
    retain: '身に付ける',
    directory: '案内',
    showRoom: '注目のホテル',
    showcases: '注目のホテル',
    promote: '宣伝',
    sell: '販売',
    info: '情報',
    rewards: 'リワード',
    media: 'メディア',
    favorites: 'お気に入り',
    contact: '連絡先',
    reportCard: '修了証書を表示',
    accountSettings: 'アカウント設定',
    messages: 'メッセージ',
    search: '検索',
  },
  contentHeaders: {
    train: '学習する',
    retain: '身に付ける',
    subapps: 'カナダスペシャリストプログラム',
    maintrainings: '基礎',
    subtrainings: '体験',
  },
  pageDescriptions: {
    train: '学習し、しっかり取り組み、エキスパートになりましょう。',
    showroom: '',
    retain:
      '専門家としての知識を身に付け、売上アップにつなげるためのリソースです。 こちらのエリアを使えば、いつでも、どこでも、どのデバイスからでも、商品に関する質問にプロとして答えたり、アドリブで営業プレゼンをしたりできます。',
    promote: 'お客様や見込み客と話し始めましょう。',
    sell: 'お客様からの質問に回答し、取引を成立させましょう。',
    favorites: 'お気に入りのコンテンツを見る',
    search: 'すべてのコンテンツを見る',
    subapps:
      'あなたの知識を次のレベルに引き上げ、各州、地域、または市の章を完了するたびにバッジを獲得しましょう。29の総章のうち10を完了すると、GOLDステータスが与えられます。29の総章のうち22を完了すると、最高のスペシャリストステータスであるPLATINUMに達します！',
    maintrainings: '基礎モジュールを完了すると、修了証書を獲得できます。',
    subtrainings: 'カナダならではの数多くの体験について知識を深め、「シルバー」ステータスを獲得しましょう。',
  },
  general: {
    forgot: 'パスワードをお忘れですか？',
    next: '次へ',
    yes: 'はい',
    no: 'いいえ',
    previous: '前へ',
    submit: '送信',
    register: '登録',
    back: '戻る',
    close: '閉じる',
    page: 'ページ',
    search: '検索',
    logIn: 'ログイン',
    logOut: 'ログアウト',
    viewItem: '{type} を表示',
    imageNotFound: '画像が見つかりません',
    noResultsFor: '{{query}} の検索結果が見つかりませんでした',
    noFavorites: 'お気に入りには何もありません',
    noMessages: 'まだメッセージを受信していません。',
    resultsFor: '{{query}} の検索結果',
    showAll: 'すべて表示',
    connectionError: '接続エラー',
    alreadyExists: 'すでにあります',
    pageNotFound: '404: ページが見つかりません。',
    oops: '申し訳ありません。',
    overview: '概要に戻る',
    complete: '続行',
    courseComplete: 'チャプターを完了しました！',
    chapterComplete: 'チャプターを完了しました！',
    message: '{count} 件のメッセージ',
    messagePlural: '{count} 件のメッセージ',
  },
  itemTypes: {
    image: '画像',
    brochure: 'コレクション',
    layout: 'レイアウト',
    web: 'ウェブサイト',
    pdf: 'PDF',
    carousel: 'コレクション',
  },
  questions: {
    dials: 'ダイヤルを回して回答に合わせてください',
    fitb: '空欄に入力してください',
    flip: '数字を変えて回答に合わせてください',
    multipleChoice: '正しい回答を選んでください',
    slider: 'スライダーを使って正しい回答を選んでください',
    map: 'マップ上で、正しいと思う場所をタップしてください',
    dropdown: '選択してください...',
    true: '正',
    false: '誤',
  },
  reportCard: {
    download: 'ダウンロード',
    email: 'Eメール',
    print: 'Print',
  },
  cookies: {
    consent: '同意',
    optout: 'オプトアウト',
    settings: 'プライバシー設定',
    message:
      'データプライバシー設定がまだ完了していません。 問題はありませんが、セールスコンパニオンの利用範囲が限られてしまいます。',
    disabled: 'クッキーが無効になっているようです。',
    use: '{{appName}} の機能を最大限に生かすには、クッキーの使用が必要となります。',
    details: 'クッキーを利用する理由は何ですか？',
    enable: 'クッキーを有効にする方法は、{{here}} をご覧ください。',
    here: 'こちら',
  },
  notLoggedIn: {
    super: 'ログインされていません',
    title: 'このコンテンツを表示するにはログインしてください。',
    guest: 'ゲスト',
  },
  demo: {
    message: '本ウェブサイトはデモです。 現在、開発中であり、完成品ではありません。',
    consent: '理解しました！',
  },
  share: {
    header: 'このリソースをお好みのソーシャルメディアでシェアしましょう！',
    download: 'ダウンロード',
  },
  sharing: {
    copyURL: 'リンクをコピー',
    copied: 'コピー済み',
    email: 'メール',
    download: 'ダウンロード',
  },
  breadCrumbs: {
    page: 'ページ',
  },
  onMobile: {
    header: 'モバイルデバイスから {appName} アプリにアクセスしようとしています',
    body: 'このプログラムをダウンロードするには、アプリストアにアクセスして {appName} を検索するか、下のボタンのひとつをクリックします',
    benefits: {
      1: 'どこでも学んで販促',
      2: '好きなデバイスでのマルチメディアトレーニング',
      3: '修了証書',
      4: 'すぐに使えるプレゼン資料',
      5: 'インパクトを高める営業資料',
      6: 'リアルタイム商品案内',
      7: 'ニュース & 最新情報',
      header: 'これにより次が提供されます。',
    },
  },
  custom: {
    splitUsers: '私はこれです:',
    brandAmbassador: 'ブランド大使',
    travelPro: '旅行業者',
  },
  rewards: {
    profile: 'Your Profile',
    rewards: 'Rewards',
    title: '報酬センター',
    subheader: 'Prizes / Points / Booking Contest',
    subTitle:
      'We’re giving you a chance to win rewards for becoming a specialist with our program, and booking travel to The Canada!',
    body: 'Book travel to The Canada for your chance to win! Enter your bookings for eligibility to earn an Introductory Incentive Reward of $5 US/CAN E-gift Card.',
    item1:
      'After your first confirmed booking of 4-nights or more, (for an individual reservation), for a minimum of two (2) passengers, at a qualifying hotel/resort. (Cruises do not qualify.)',
    item2: 'Offer valid after Essential Modules of the Canada Specialist Programme Program are completed.',
    link1: 'Have you booked the Canada? ',
    link2: 'If so, submit your booking here.',
    button: 'Submit your booking',
    products: 'Marketplace',
    viewAllBookings: 'Bookings Dashboard',
    viewLeaderboard: 'Leaderboard',
    viewDashboard: '実績ダッシュボード',
    viewRewards: '報酬ホーム',
    form: 'SUBMIT BOOKING ',
    overview: {
      title: 'カナダ・スペシャリスト・リワード・センターへようこそ。',
      subtitle: 'この特別セクションは、トレーニングの進捗状況、成果、報酬を記録するために使用します。 ',
      description: 'その方法はこうだ：',
      dashboard: {
        title: '実績ダッシュボード',
        description:
          'アチーブメント・ダッシュボードにアクセスして、トレーニングの進捗状況、ディプロマ、獲得したバッジを追跡してください。ブロンズ・レベルからプラチナ・レベルへ進むにつれ、トラッカー・バーで自分のステータスが上がっていくのを見ることができます。',
        bronze: 'ファウンデーション・チャプターを修了すると、BRONZEステータスが与えられる。',
        silver: 'シルバーのステータスは、エクスペリエンス・チャプターを修了すると、ディプロマとともに取得できます。',
        gold: 'GOLDステータスは、10の州／準州／都市のチャプターを完了すると獲得できます。',
        platinum: 'プラチナ・ステータスは、22の州／準州／都市のチャプターを修了した場合に獲得できる。',
      },
      platinumRewards: {
        title: 'プラチナ特典',
        description:
          'プラチナ・レベルのカナダ・スペシャリストは、デスティネーション・パートナーからデスティネーション・エクスペリエンス・パスのような特別な特典を獲得できます。実績ダッシュボードでプラチナバッジを受け取ると、利用可能なエクスペリエンスパスのリストと引き換え方法が表示されます。プラチナ・バッジをダウンロードして、デスティネーション・パートナーに送信してください。',
      },
      downloads: {
        title: 'ダウンロード',
        description:
          'アチーブメント・ダッシュボードでは、カナダ・スペシャリストのディプロマ、州／地域／都市のバッジ、メタリック・ステータスのバッジを表示し、ダウンロードすることができます。アイコンをクリックしてコンピュータに保存し、顧客や見込み客に自慢してください。',
      },
      termsNotice: {
        start: 'See terms',
        end: 'for more details.',
        link: ' Terms & Conditions ',
      },
      rewards: {
        title: 'Rewards',
        description: {
          start: 'Platinum-level Canada Specialists earn special rewards like',
          end: "from our destination partners. Once you receive your Platinum badge in the Achievements Dashboard, you'll get a list of the available Experience Passes and instructions for redemption.",
          bold: 'Destination Experience Passes',
        },
      },
    },
    bookingRewardsView: {
      title: 'Marketplace',
    },
    bookingsView: {
      title: 'BOOKINGS DASHBOARD',
    },
    leaderboardScreen: {
      title: 'LC POINTS \n Leaderboard',
      earnedpts: 'MY LC POINTS EARNED​:',
      pointsWall: 'LC POINTS TOP 5 TRACKER​:',
      startEarning: "Start now earning XP's and join the leaderboard!",
      prizes: 'Prizes',
      tAndC: 'Terms and Conditions apply*',
      pointsOverview: {
        title: 'How to earn points',
        booths: 'Visit Exhibitor Showcases',
        breakoutSessions: 'Attend Breakout Sessions & Destination Spotlights',
        trainingSessions: 'Complete a Training Chapter',
        adventureSpotlights: 'Family Travel Tips',
        share: 'Sharing Content',
        shareMax: '(up to {maxSharePoints} points)',
        shareInfo:
          'Sharing is counted by sharing booth content to Twitter and Facebook or sharing the entire booth with colleagues or clients.',
        viewVideo: 'View Video',
      },
    },
    dashboardView: {
      title: 'Your Earnings Dashboard',
    },
    bookingForm: {
      title: 'BOOKING CREDIT FORM​',
      subTitle: 'Your Profile',
      required: '* Indicates a required field',
      email: 'Advisor email',
      agentFirstName: 'Advisor First Name',
      agentLastName: 'Advisor Last Name',
      company: 'Agency / Company Name',
      iata: 'IATA/CLIA #',
      stateProvince: 'State/ Province',
      postalCode: 'Zip / Postal Code',
      country: 'Country',
      city: 'City',
      birthday: 'Birthday',
      type: 'Guest Trip Type',
      source: 'Booking Source',
      tourOperator: 'Tour Operator',
      firstName: 'Guest First Name',
      lastName: 'Guest Last Name',
      confirmNumber: 'Booking Confirm Number',
      file: 'RezSnap™ Proof Upload ',
      arrivalDate: 'Property Arrival Date',
      departureDate: 'Property Departure Date',
      brand: 'LC Brand Booked',
      lengthOfStay: 'Length of Stay (in Nights)',
      cost: 'Total Cost of Booking',
      rooms: 'Number of Rooms',
      stay: 'Length of Stay (in Nights)',
      airline: 'Airline/ Carrier (2- digit code)',
      gateway: 'Origin Gateway (3- letter airport code)',
      destination: 'Destination/ island (3- letter airport code)',
      disclaimer: '* Required fields',
      button: 'Submit your booking',
      sub: 'Your information',
      sub2: 'Booking information',
    },
    TermsAndConditions: {
      title: 'Terms and Conditions',
      subTitle: 'Canada Specialist Quarterly Rewards',
      body1:
        'All posting must be accompanied by a zero-balance proof of sale document that corresponds with each individual booking that you have posted. Awardees will be selected based on the totality of verified proof of sale documents corresponding with each listed booking. Postings must follow all Bahamas Specialist Rewards rules for eligibility. Awards are not transferable and must be redeemed within three (3) months of award notification. Any unused, unclaimed or declined awards will be forfeited. Awards will be issued quarterly, and eligibility will be verified based on completed travel.',
      body2:
        'To be eligible you must reside in the U.S or Canada, and be age of majority or older in the state, province, or territory of residence. Tour Operator employees are NOT eligible for drawings, and will NOT be considered for additional prizes. Residents of the Province of Quebec are NOT eligible for drawings, and will NOT be considered for additional prizes.',
      body3:
        'Reward issuance may require proof of accreditation as a retail/home-based travel counselor. Available rewards are subject to change during the course of the program.',
      body4: 'Privacy and Use of Personal Information',
      body5:
        'Participating agents (i) grants to the Rewarder the right to use his/her name, city, state, province, postal code, age of majority confirmation, telephone number and e-mail address for including but not limited to contacting and announcing the Awardees and provision of awards; (ii) grants to the Awardee the right to use his/her personal information for publicity and promotional purposes relating to the awards, in any and all media now known or hereafter devised, without further compensation unless prohibited by law; and (iii) acknowledges that the Awardees may disclose his/her personal information to third-party agents and service providers in connection with any of the activities listed in (i) and (ii) above.',
      button: 'Return to landing',
    },
    thankYouPage: {
      thanks: 'Thank you',
      congrats: 'Congratulations, ',
      body: 'your booking has been received and sent to the campaign supervisor for verification.',
      link: 'Please note to be a winner, you must have completed the Essential Modules of the Canada Specialist Program',
    },
  },
  badgeView: {
    title: '績ダッシュボード',
    subtitle: 'ディプロマバッジとスペシャリゼーションバッジを表示、追跡、ダウンロードできます',
    viewBadge: 'ステータスを見る',
    badgeDisplayTitle: '達成状況',
    badgeAchievement:
      '      「｛rank｝ ステータスを達成しました！下のバッジのアイコンをクリックして、ステータスを確認したり共有したりできます。」',
    badgesCompleteTitle: 'あなたの専門バッジ',
    badgesCompleteSubtitle: 'バッジを表示、保存、共有するにはアイコンをクリックしてください、',
    badgesIncompleteSubtitle: 'これらの章を完了することで、さらにバッジを獲得できます',
    bronze: 'ブロンズ',
    silver: 'シルバー',
    gold: 'ゴールド',
    platinum: 'プラチナ',
    diploma: 'ディプロマ',
    badgeAchievementWithRewards: {
      start: 'おめでとうございます！プラチナステータスに到達しました。をクリックしてください、',
      link: 'here',
      end: ' をクリックして、プラチナ・ステータス特典にアクセスしてください、',
    },
  },
  search: {
    pages: 'Pages',
    resources: 'Resources',
  },
};
